<template>
  <div class="form form-card">
    <div class="form-card__container form-card__container--sm">
      <el-form
        ref="MemberForm"
        class="member-modify__form"
        :model="MemberForm"
        :rules="MemberRules"
        label-position="top"
        @submit.prevent.native
      >
        <div class="form-readonly">
          <label class="form-label">{{ $t('memberModify.label.account') }}</label>
          <div class="form-readonly__value">{{ MemberForm.memberAccount }}</div>
        </div>

        <el-form-item prop="memberName" class="form-field">
          <label class="form-label">{{ $t('memberModify.label.name') }}</label>
          <el-input
            v-model="MemberForm.memberName"
            :placeholder="$t('memberModify.placeholder.name')"
            type="text"
            size="large"
            prefix-icon="el-icon-user"
          />
        </el-form-item>

        <div class="form-group form-group--address">
          <label class="form-label">{{ $t('memberModify.label.address') }}</label>
          <div class="form-group--grid-address">
            <el-form-item prop="memberZipCode" class="form-field">
              <el-input
                v-model="MemberForm.memberZipCode"
                :placeholder="$t('memberModify.placeholder.zipCode')"
                disabled
                size="large"
              />
            </el-form-item>

            <el-form-item prop="memberCounty" class="form-field">
              <el-select
                v-model="MemberForm.memberCounty"
                :placeholder="$t('memberModify.placeholder.county')"
                size="large"
                @change="SetCityList(1)"
              >
                <el-option
                  v-for="item in CountyOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>

            <el-form-item prop="memberCity" class="form-field">
              <el-select
                v-model="MemberForm.memberCity"
                :placeholder="$t('memberModify.placeholder.city')"
                size="large"
                @change="SetZipCode()"
              >
                <el-option
                  v-for="item in CityOption"
                  :key="item.label"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </div>

          <el-form-item prop="memberAddress" class="form-field">
            <el-input
              v-model="MemberForm.memberAddress"
              :placeholder="$t('memberModify.placeholder.detailAddress')"
              type="text"
              size="large"
              prefix-icon="el-icon-location"
            />
          </el-form-item>
        </div>

        <button
          class="btn-submit"
          @click="ModifyMember"
        >
          {{ $t('common.button.save') }}
        </button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { MemberById, ModifyMember } from '@/api/MemberApi';
import { GetCountyList, GetCityList } from '@/lib/zipcode';

export default {
  data() {
    // 建立你的初始化 model data
    return {
      MemberForm: {
        //  model data
        memberId: 0,
        memberAccount: '',
        memberName: '',
        memberMail: '',
        memberPhone: '',
        memberZipCode: '',
        memberCounty: '',
        memberCity: '',
        memberAddress: '',
        inSchool: 0,
        schoolId: 0,
        schoolDeptId: 0,
        schoolYearId: 0,
      },
      MemberRules: {
        // 檢查輸入的值規則
        memberName: [{ required: true, message: this.$t('validation.nameRequired'), trigger: 'blur' },
          { pattern: /^[\u4E00-\u9FFF\u3400-\u4DBF\u{20000}-\u{2A6DF}\u{2A700}-\u{2B73F}\u{2B740}-\u{2B81F}\u{2B820}-\u{2CEAF}\u{2CEB0}-\u{2EBEF}]*$/u, message: this.$t('validation.nameChineseOnly'), trigger: 'blur' }],
        memberZipCode: [{ required: true, message: this.$t('validation.zipCodeRequired'), trigger: 'blur' }],
        memberCounty: [{ required: true, message: this.$t('validation.countyRequired'), trigger: 'change' }],
        memberCity: [{ required: true, message: this.$t('validation.cityRequired'), trigger: 'change' }],
        memberAddress: [{ required: true, message: this.$t('validation.addressRequired'), trigger: 'blur' }],
      },
    };
  },
  created() {
    // 一開始執行的地方
    this.GetMemberData();
  },
  methods: {
    SetCountyList() {
      this.CountyOption = GetCountyList();
    },
    SetCityList(clear) {
      this.CityOption = GetCityList(this.MemberForm.memberCounty);
      if (clear === 1) {
        this.MemberForm.memberCity = '';
        this.MemberForm.memberZipCode = '';
      } else {
        const data = this.CityOption.filter((item) => this.MemberForm.memberCity === item.label);
        if (!data[0]) {
          this.MemberForm.memberCity = '';
          this.MemberForm.memberZipCode = '';
        }
      }
    },
    SetZipCode() {
      const data = this.CityOption.filter((item) => this.MemberForm.memberCity === item.label);
      if (data[0]) {
        this.MemberForm.memberZipCode = data[0].value;
      } else {
        this.MemberForm.memberZipCode = '';
      }
    },
    GetMemberData() {
      MemberById().then((response) => {
        if (response.data.statusCode === 0) {
          this.MemberForm = response.data.data;
          this.SetCountyList();
          this.SetCityList(0);
        }
      });
    },
    ModifyMember() {
      // 儲存按鈕
      this.$refs.MemberForm.validate((valid) => {
        if (valid) {
          ModifyMember(this.MemberForm).then((response) => {
            if (response.data.statusCode === 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('memberModify.message.success'),
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('common.message.fillAllFields'),
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.member-modify-page {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-lg);
  background: var(--background-base);

  &__container {
    width: 100%;
    max-width: 600px;
    padding: 48px 40px;
    background: var(--background-white);

    @media (max-width: $breakpoint-sm) {
      padding: 32px 24px;
    }

    @media (max-width: $breakpoint-xs) {
      padding: 24px 16px;
    }
  }
}

.member-modify-form {
  // 通用表單樣式
  .form-readonly {
    margin-bottom: 32px;
    padding: 16px;
    background: var(--background-base);
    border-radius: var(--border-radius-base);
    border: 1px solid var(--border-lighter);

    &__value {
      color: var(--text-primary);
      font-size: var(--font-size-base);
      font-weight: 500;
    }

    @media (max-width: $breakpoint-sm) {
      margin-bottom: 28px;
      padding: 12px;
    }

    @media (max-width: $breakpoint-xs) {
      margin-bottom: 24px;
    }
  }

  .form-field {
    margin-bottom: 32px;

    @media (max-width: $breakpoint-sm) {
      margin-bottom: 28px;
    }

    @media (max-width: $breakpoint-xs) {
      margin-bottom: 24px;
    }
  }

  .form-label {
    display: block;
    margin-bottom: 8px;
    color: var(--text-primary);
    font-size: 15px;
    font-weight: 600;
    line-height: 1.2;
  }

  .form-group {
    &--address {
      margin-bottom: 32px;

      @media (max-width: $breakpoint-sm) {
        margin-bottom: 28px;
      }

      @media (max-width: $breakpoint-xs) {
        margin-bottom: 24px;
      }
    }

    &--grid-address {
      display: grid;
      grid-template-columns: 100px 1fr 1fr;
      gap: 12px;
      margin-top: 8px;
      margin-bottom: 12px;

      .form-field {
        margin-bottom: 0;
      }

      @media (max-width: $breakpoint-sm) {
        grid-template-columns: 1fr;
        gap: 12px;
      }
    }
  }

  .btn-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 48px;
    margin-top: 32px;
    background: var(--primary-darken-color);
    color: #ffffff !important;
    font-size: var(--font-size-base);
    font-weight: 600;
    border: none;
    border-radius: var(--border-radius-base);
    cursor: pointer;
    transition: var(--transition-fast);

    &:hover {
      opacity: 0.9;
    }

    ::v-deep span {
      color: #ffffff !important;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
    padding-bottom: 22px;
  }

  ::v-deep .el-form-item__content {
    line-height: 1;
  }

  ::v-deep .el-form-item__error {
    padding-top: 6px;
    font-size: 13px;
    line-height: 1.4;
    position: absolute;
    bottom: 0;
  }

  ::v-deep .el-input__inner {
    height: 40px;
    line-height: 40px;
    border: 1px solid #777;
    border-radius: var(--border-radius-base);
    transition: var(--transition-fast);

    &:hover,
    &:focus {
      border-color: var(--primary-darken-color);
    }

    &:disabled {
      background: var(--background-base);
      border-color: var(--border-lighter);
      color: var(--text-secondary);
      cursor: not-allowed;
    }
  }

  ::v-deep .el-input__prefix {
    display: flex;
    align-items: center;
    left: 12px;
  }

  ::v-deep .el-input__icon {
    line-height: 40px;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-select .el-input__inner {
    padding-left: 12px;
  }
}

@media (max-width: $breakpoint-sm) {
  .member-modify-form {
    .form-field {
      margin-bottom: 28px;
    }

    .form-label {
      font-size: 14px;
      margin-bottom: 6px;
    }

    ::v-deep .el-input__inner {
      height: 38px;
      line-height: 38px;
    }

    ::v-deep .el-input__icon {
      line-height: 38px;
    }
  }
}

@media (max-width: $breakpoint-xs) {
  .member-modify-page {
    padding: var(--spacing-md);
  }

  .member-modify-form {
    .form-field {
      margin-bottom: 24px;
    }

    .form-label {
      font-size: 13px;
    }

    ::v-deep .el-input__inner {
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input__icon {
      line-height: 36px;
    }
  }
}
</style>
